import { render, staticRenderFns } from "./ProductsOnOfferCombo.vue?vue&type=template&id=58a2055b&scoped=true"
import script from "./ProductsOnOfferCombo.vue?vue&type=script&lang=js"
export * from "./ProductsOnOfferCombo.vue?vue&type=script&lang=js"
import style0 from "./ProductsOnOfferCombo.vue?vue&type=style&index=0&id=58a2055b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a2055b",
  null
  
)

export default component.exports